import { render, staticRenderFns } from "./teachingUploadDialog.vue?vue&type=template&id=792fe7c2"
import script from "./teachingUploadDialog.vue?vue&type=script&lang=js"
export * from "./teachingUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./teachingUploadDialog.vue?vue&type=style&index=0&id=792fe7c2&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports